<template>
  <div>
    <b-row>
      <b-col cols="12" md="6"
        >{{ $lang.second_interview_context }} :
        {{
          item.second_interview_context && item.second_interview_context.caption
        }}</b-col
      >
      <b-col cols="12" md="6"
        >{{ $lang.second_interview_field }} :
        {{
          item.second_interview_field && item.second_interview_field.caption
        }}</b-col
      >
      <b-col cols="12" md="6"
        >{{ $lang.first_interview_context }} :
        {{
          item.first_interview_contex && item.first_interview_context.caption
        }}</b-col
      >
      <b-col cols="12" md="6"
        >{{ $lang.first_interview_field }} :
        {{
          item.first_interview_field && item.first_interview_field.caption
        }}</b-col
      >
      <b-col cols="12">
        <b-form-checkbox
          @change="patchPersonCooperation"
          v-model="checked"
          name="check-button"
          switch
        >
          <b> {{ $lang.confirm_selected_courses }} </b>
        </b-form-checkbox>
      </b-col>
      <b-col cols="12" md="12" class="float-right">
        <div slot="footer" class="form-group form-btn">
          <b-button
            type="reset"
            class="ml-2"
            size="md"
            variant="danger"
            @click="cancel"
          >
            <i class="fa fa-ban"></i>
            {{ $lang.cancelButton }}
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    code: {
      type: String,
    },
  },
  inject: ["personResearchInterviewRepository"],
  data() {
    return {
      item: {},
      checked: false,
    };
  },
  methods: {
    async fetchData() {
      try {
        const response = await this.personResearchInterviewRepository.find(
          this.code
        );
        let { data } = response.data;

        this.item = data;
        if (data) {
          this.checked =
            data && data.interview_field_accept == 1 ? true : false;
        }
      } catch (error) {
        this.$generateError(error);
      }
    },
    async patchPersonCooperation() {
      try {
        let payload = {
          interview_field_accept: this.checked !== false ? 0 : 1,
        };
        const response =
          await this.personResearchInterviewRepository.partial_edit(
            this.code,
            payload
          );
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
        this.checked = false;
      }
    },
    cancel() {
      this.$emit("cancel");
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

<style>
</style>
